import { MAX_PIN_LENGTH } from '@/consts';
import { checkSessionAndRedirect, tryPinCheck } from '@/core/presenter/controller/LoginController';
import { useCallback, useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import * as ViewModel from '@/core/presenter/viewModel';
import { encryptPassword } from '@/core/domain/usecases/passwordUsecase';
import { tryGetIsLockedUser, trySendCoinAndToken } from '@/core/presenter/controller/HomeController';
import { useStores } from '@/stores';
import { RouterPath } from '@/routes/RouterPath';

// Location state 타입 정의
interface LocationState {
  returnPath?: string;
  isSendView?: boolean;
  sendData?: {
    address: string;
    asset: string;
    selectedAsset?: ViewModel.IAsset;
    assetSymbol?: string;
  };
  userId?: string;
  userPhone?: string;
  from?: string;
  to?: string;
  amount?: number;
  memo?: string;
}

export default function usePin() {
  const [pin, setPin] = useState<string>('');
  const [isPinCheckFailed, setIsPinCheckFailed] = useState<boolean>(false);
  const [isLockedModalOpen, setIsLockedModalOpen] = useState<boolean>(false);
  const navigate = useNavigate();
  const location = useLocation();
  // location.state의 타입을 LocationState로 타입 단언
  const state = location.state as LocationState;
  const { userStore } = useStores();

  useEffect(() => {
    const checkAuth = async () => {
      await checkSessionAndRedirect();
    };
    checkAuth();
  }, []);

  /** 숫자 버튼 클릭 이벤트 */
  const onClickNumberBtn = useCallback(
    async (number: string) => {
      if (pin.length < MAX_PIN_LENGTH) {
        const newPin = pin + number;
        setPin(newPin);

        if (newPin.length === MAX_PIN_LENGTH) {
          const userId = state?.userId || '';
          const encryptedPin = await encryptPassword(state.userPhone ?? '', newPin);
          const isSuccess = await tryPinCheck(userId, encryptedPin);

          console.log('isSuccess', isSuccess);

          if (isSuccess.succed) {
            const isLocked = await tryGetIsLockedUser(userStore.user?.phone ?? '');

            console.log('isLocked', isLocked);



            if (isLocked.result === 'locked') {
              setIsLockedModalOpen(true);
              return;
            }


            // PIN 인증 성공 시 전송 요청과 화면 이동을 동시에 진행
            const sendRequest =
              state?.sendData?.assetSymbol === ViewModel.AssetType.TOKEN
                ? trySendCoinAndToken({
                  id: userId,
                  phone: state?.userPhone ?? '',
                  from: state?.from ?? '',
                  to: state?.to ?? '',
                  amount: state?.amount ?? 0,
                  memo: state?.memo ?? '',
                  isToken: 'y',
                })
                : trySendCoinAndToken({
                  id: userId,
                  phone: state?.userPhone ?? '',
                  from: state?.from ?? '',
                  to: state?.to ?? '',
                  amount: state?.amount ?? 0,
                  memo: state?.memo ?? '',
                  isToken: 'n',
                });

            // 전송 요청과 동시에 보내기 화면으로 이동하여 모달 표시
            if (state?.returnPath) {
              navigate(state.returnPath, {
                state: {
                  isSendView: state?.isSendView,
                  sendData: state?.sendData,
                },
                replace: true,
              });
            } else {
              navigate('/home', {
                state: {
                  isSendView: state?.isSendView,
                  sendData: state?.sendData,
                },
                replace: true,
              });
            }

            // 전송 요청은 백그라운드에서 진행 (await 하지 않음)
            sendRequest.catch((error) => {
              console.error('전송 요청 실패:', error);
            });
          } else {
            setIsPinCheckFailed(true);
            setPin('');
          }
        }
      }
    },
    [pin, navigate, state],
  );

  /** 삭제 버튼 클릭 이벤트 */
  const OnClickDeleteBtn = useCallback(() => {
    setPin(pin.slice(0, -1));
  }, [pin]);

  /** 전체 삭제 버튼 클릭 이벤트 */
  const onClickAllClearBtn = useCallback(() => {
    setPin('');
  }, []);

  /** 출금 제한 모달 확인 버튼 클릭 이벤트 */
  const onClickLockedModalConfirm = useCallback(() => {
    setIsLockedModalOpen(false);
    navigate(RouterPath.HOME, { replace: true });
  }, [navigate]);

  return {
    pin,
    isPinCheckFailed,
    isLockedModalOpen,
    onClickNumberBtn,
    OnClickDeleteBtn,
    onClickAllClearBtn,
    onClickLockedModalConfirm,
  };
}
